module.exports = __webpack_public_path__ + "static/media/IMG_1735.01dff865.jpg";